export const addressData = [
    {
      firstLine: "Home",
      houseName: "Salmiya Block 11",
      buildingNumber: "Hamoud Al Nasser St.",
      floor: "Floor: 13 Apt: 25",
      number: "Alt. Number: +96555992092",
    },
    {
      firstLine: "Office",
      houseName: "Ardiya Block 2",
      buildingNumber: "Sagher Al Nesafi Street",
      floor: "Floor: 2 Marketing Office",
      number: "Alt. Number: +96555992092",
    },
    {
      firstLine: "Warehouse",
      houseName: "Jahra Block 7",
      buildingNumber: "Industrial Area Road",
      floor: "Floor: 1 Warehouse B",
      number: "Alt. Number: +96555992092",
    },
  ];
  